var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "structure-panel" },
    [
      _c("MolstarStructureViewer", {
        ref: "viewer",
        attrs: {
          scene: _vm.scene,
          sceneInput: _vm.sceneInput,
          toolbar: _vm.toolbar,
          bgColorLight: _vm.bgColorLight,
          bgColorDark: _vm.bgColorDark,
        },
        on: {
          makeImage: _vm.handleMakeImage,
          makeCIF: _vm.handleMakeCIF,
          toggleQuery: _vm.handleToggleQuery,
          toggleTarget: _vm.handleToggleTarget,
          sceneEvent: _vm.handleSceneEvent,
        },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _c(
                  "table",
                  {
                    staticClass: "tmscore-panel",
                    class: { fullscreen: _vm.isFullscreen },
                  },
                  [
                    _c("tr", [
                      _c("td", { staticClass: "left-cell" }, [
                        _vm._v("idf-score:"),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "right-cell" }, [
                        _vm._v(_vm._s(_vm.alignment.idfscore)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "left-cell" }, [_vm._v("RMSD:")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "right-cell" }, [
                        _vm._v(_vm._s(_vm.alignment.rmsd)),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("StructureHoverTooltip", {
                  attrs: { value: _vm.hoverInfo },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }